import { getCurrentDomain } from '../../host';

import categories from './categories';
import language from './language';

export default {
  cookie: {
    domain: `.${getCurrentDomain()}`,
    path: '/',
    expiresAfterDays: 365,
  },
  categories,
  language,
  revision: 2,
  outdatedCookies: [{ name: /^ma_/, domain: `.${getCurrentDomain()}` }],
};
